import React from 'react'
import PropTypes from 'prop-types'
import DayColumn from './DayColumn'

const CalendarDays = ({ handleBookingClick, numHours, startOfWeek }) => {
  const week = []
  for (let i = 0; i < 7; i++) {
    week.push(startOfWeek.clone().add(i, 'day'))
  }
  return (
    <div>
      {week.map(dayOfTheWeek => (
        <DayColumn
          date={dayOfTheWeek.clone()}
          key={`${dayOfTheWeek}`}
          numHours={numHours}
          handleBookingClick={handleBookingClick}
        />
        ))}
    </div>
  )
}

CalendarDays.propTypes = {
  handleBookingClick: PropTypes.func.isRequired,
  numHours: PropTypes.number.isRequired,
  startOfWeek: PropTypes.shape({
    clone: PropTypes.func.isRequired,
  }).isRequired,
}

export default CalendarDays



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/CalendarDays.js